import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useLocation } from 'react-router-dom';
import { API_BASE_URL } from '../config/apiConfig';

const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};

const TrackOrder = () => {
  const query = useQuery();
  const initialOrderId = query.get('trackingNumber') || '';

  const [orderId, setOrderId] = useState(initialOrderId);
  const [order, setOrder] = useState(null);
  const [error, setError] = useState('');

  const fetchOrder = (id) => {
    if (!id) return;

    fetch(`${API_BASE_URL}/api/orders/by-tracking/${id}`)
      .then(res => {
        if (!res.ok) throw new Error('Order not found.');
        return res.json();
      })
      .then(data => {
        setOrder(data);
        setError('');
      })
      .catch(err => {
        setOrder(null);
        setError('Order not found. Please check your tracking number.');
        console.error('Failed to fetch order:', err);
      });
  };

  useEffect(() => {
    if (initialOrderId) {
      fetchOrder(initialOrderId);
    }
  }, [initialOrderId]);

  const handleTrackOrder = () => {
    if (!orderId.trim()) return;
    fetchOrder(orderId.trim());
  };

  const statusSteps = ['Order Placed', 'Processing', 'In Processing', 'Processed', 'Shipped', 'Out for Delivery', 'Delivered'];

  const getCurrentStep = (status) => {
    return statusSteps.indexOf(status);
  };

  return (
    <>
      <Header />

      <main className="rbt-main-wrapper">
        <section className="order-tracking-section">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-8 col-md-10 col-12">
                <div className="order-tracking-box">
                  <h2 className="order-tracking-title">Track Your Order</h2>
                  <p className="order-tracking-text">
                    {order ? `Tracking Number: ${order.trackingNumber}` : 'Enter your tracking number below to track your shipment.'}
                  </p>

                  <div className="order-tracking-input-group">
                    <input
                      type="text"
                      className="order-tracking-input"
                      placeholder="Enter Tracking Number"
                      value={orderId}
                      onChange={(e) => setOrderId(e.target.value)}
                    />
                    <button className="order-tracking-btn" onClick={handleTrackOrder}>Track Order</button>
                  </div>

                  {error && <p style={{ color: 'red', marginTop: '10px' }}>{error}</p>}

                  {order && (
                    <>
                      <div className="order-status mt-4">
                        <ul className="order-tracking-steps">
                          {statusSteps.map((step, index) => {
                            const currentStepIndex = getCurrentStep(order.orderStatus);
                            const isCompleted = index <= currentStepIndex;
                            const isActive = index === currentStepIndex + 1;

                            return (
                              <li
                                key={index}
                                className={`order-step ${isCompleted ? 'completed' : ''} ${isActive ? 'active' : ''}`}
                              >
                                {step}
                              </li>
                            );
                          })}
                        </ul>
                      </div>

                      <div className="order-details mt-4 p-3" style={{ border: '1px solid #ddd', borderRadius: '10px' }}>
                        <h5>Order Details</h5>
                        {/* <p><strong>Order ID:</strong> {order.orderID}</p> */}
                        {/* <p><strong>Status:</strong> {order.orderStatus}</p> */}
                        <p><strong>Payment:</strong> {order.paymentStatus}</p>
                        <p><strong>Total Amount:</strong> ${order.totalAmount.toFixed(2)}</p>

                        {order.items && order.items.length > 0 && (
                          <div className="mt-3">
                            <h6>Items:</h6>
                            <ul>
                              {order.items.map((item, idx) => (
                                <li key={idx}>
                                  {item.productName} ({item.fabricName}) - ${item.price.toFixed(2)}
                                </li>
                              ))}
                            </ul>
                          </div>
                        )}
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />

      <div className="rbt-progress-parent">
        <svg className="rbt-back-circle svg-inner" width="100%" height="100%" viewBox="-1 -1 102 102">
          <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
        </svg>
      </div>
    </>
  );
};

export default TrackOrder;
